export default {
  getMarketManOrder: (state) => state.marketManOrder,
  buyers: (state) => [...new Set(state.marketManOrders.map((buyer) => ({
    buyerName: buyer.buyerName,
    buyerGuid: buyer.buyerGuid,
  })))],
};
